import { HttpErrorResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApolloError} from '@apollo/client';
import {TranslateService} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {ToastrService} from 'ngx-toastr';
import {EMPTY, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {}

  handleApollo(error: ApolloError): Observable<never> {
    if (error.networkError && error.networkError instanceof HttpErrorResponse && error.networkError.status === 0) {
      this.toastr.error(this.translate.instant('CHECK_YOUR_INTERNET_CONNECTION'));
    } else if (error.message !== '') {
      this.toastr.error(error.message);
    } else {
      this.toastr.error(this.translate.instant('SOMETHING_WENT_WRONG'));
    }
    return EMPTY;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleRESTError(error: any): void {
    if (error.status >= 400 && error.status < 500) {
      this.showToastrWithTitle(error.error.detail);
    } else {
      this.showToastrWithTitle(`${this.translate.instant('AN_UNKNOWN_ERROR_HAS_OCCURRED')}`);
      if (environment.production) {
        Sentry.captureException(error);
      } else {
        console.error(error);
      }
    }
  }

  private showToastrWithTitle(message: string, location?: string): void {
    this.toastr.error(
      location ? `An error occurred in ${location}: ${message}` : message,
      this.translate.instant('SOMETHING_WENT_WRONG'),
    );
  }
}
